<template>
  <div>
    <div class="text-center">
      <!-- <img src="/improvee_logo.svg" class="flex-1 fill-current text-primary" height="40" /> -->
      <!-- <h3 id="academy-header" :hideAdd="true"> -->
        <!-- <span class="font-normal">improvee.io</span> academy -->
      <!-- </h3> -->
    </div>
<!--     <vs-row vs-type="flex" vs-justify="space-around" class="mt-4">
      <vs-col class="text-center" vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="12" vs-w="8" vs-lg="8">
       <h5>guide to happier and healthier you</h5>
      </vs-col>
    </vs-row> -->

<!--     <vs-row vs-type="flex" vs-justify="space-around" class="mt-8">
      <vs-col class="text-center" vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="12" vs-w="8" vs-lg="8">
       <h4>No matter what you really want to accomplish in your life, this academy is the foundation to get you there.</h4>
      </vs-col>
    </vs-row> -->

<!--     <vs-row vs-type="flex" vs-justify="space-around" class="mt-8">
      <vs-col class="text-center" vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="12" vs-w="8" vs-lg="8">
       <h3 class="font-semibold mb-2">Discover more about yourself and release your full potential</h3>
      </vs-col>
    </vs-row> -->
<!--
    <div class="flex items-center">
      <img src="@/assets/images/member.png" alt="Image" class="mx-auto mb-4">
    </div> -->

    <div class="text-center mt-8 flex justify-center">
       <h2 class="font-bold w-full md:w-1/2">What you will learn</h2>
    </div>

    <div class="flex justify-center">

<div class="vx-row mt-2 xl:w-3/4">
          <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">

            <ClaimCard
                  hideChart
                  icon="CompassIcon"
                  claim="Set purposeful goals and create working systems"
                  color="primary" />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
                <ClaimCard
                  hideChart
                  icon="SmileIcon"
                  claim="Learn how to be happy and successful"
                  color="primary" />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
                <ClaimCard
                  hideChart
                  icon="AwardIcon"
                  claim="Find intrinsic motivation and enjoy the process"
                  color="primary" />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
                <ClaimCard
                  hideChart
                  icon="BarChartIcon"
                  claim="Create habits that will actually stick"
                  color="primary" />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
                <ClaimCard
                  hideChart
                  icon="ShieldIcon"
                  claim="Evaluate how you spend your limited time"
                  color="primary" />
            </div>

            <div class="vx-col w-1/2 md:w-1/3 xl:w-1/3">
                <ClaimCard
                  hideChart
                  icon="TrendingUpIcon"
                  claim="Create an action plan and destroy limitations"
                  color="dark" />
            </div>
        </div>

    </div>

<!--     <div class="text-center mt-8 flex justify-center">
       <p class="lg:w-3/5 text-black text-2xl">No matter what you really want to accomplish in your life, this academy is the first step to finally get there.</p>
    </div> -->

<!--     <div class="text-center mt-4">
      <h5>Improvee.io is a tool, a system, for those who want to spend their time wisely and make the most of it. Academy is a supplement that teaches you the most important knowledge to finally get the right things done.</h5>
    </div> -->

    <div class="text-center mt-6 flex justify-center">
       <p class="lg:w-1/2 text-lg text-dark">Improvee.io is a tool, a system, for those who want to spend their time wisely and make the most of it.</p>
    </div>


    <div class="mt-6 flex justify-center">
        <slot></slot>
    </div>

    <div>
      <img src="@/assets/images/study-from-books.svg" class="mx-auto w-3/4 lg:w-1/2 mt-2"/>
    </div>




<!--     <vs-row vs-type="flex" vs-justify="space-around" class="">
      <vs-col class="text-center mt-4" vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="12" vs-w="9" vs-lg="6">
       <p class="text-lg">Improvee.io is a tool, a system, for those who want to spend their time wisely and make the most of it.</p>
      </vs-col>
    </vs-row> -->




  </div>

</template>

<script>
import ClaimCard from './ClaimCard'

export default {
  components: {
    ClaimCard
  },
  props: {
  },
  computed: {
  },
}

</script>


<style scoped lang="scss">

</style>
